import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const FinalCTA = () => {
  const scrollToBooking = () => document.getElementById('booking-section')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="py-24 border-t" style={{ background: '#0d0d0d', borderColor: '#1a1a1a' }}>
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 leading-tight" style={{ color: '#f1f1f1' }}>
            Stop sending missed calls<br />to voicemail.
          </h2>
          <p className="text-lg mb-10 leading-relaxed" style={{ color: '#666' }}>
            Keep your current number. Let your team answer first.<br />Let AI catch the rest.
          </p>
          <button onClick={scrollToBooking}
            className="group inline-flex items-center gap-3 px-10 py-5 rounded-xl text-lg font-semibold transition-all"
            style={{ background: '#f1f1f1', color: '#0a0a0a' }}>
            Book a Discovery Call
            <SafeIcon icon={FiArrowRight} className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
          <p className="text-sm mt-6" style={{ color: '#444' }}>15-minute call. We'll scope your workflow and answer any questions.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;